import { API, graphqlOperation } from "aws-amplify";
import { get_s3_file } from "@/graphql/queries.js";
import axios from "axios";
export const GenerateS3URL = {
  data: () => ({}),
  methods: {
    async GenerateS3URLMethods(key) {
      try {
        this.overlay = true;
        let result = await API.graphql(
          graphqlOperation(get_s3_file, {
            key: key,
          })
        );
        const ResultObj = await JSON.parse(result.data.get_s3_file);
        if (ResultObj.status === "Success") {
          this.overlay = false;
          console.log("key", key);
          if (
            key.includes("LICENSE_BACK") ||
            key.includes("LICENSE_FRONT") ||
            key.includes("PROFILE_PIC")
          ) {
            return this.UploadS3method(ResultObj.message, key);
          } else {
            return ResultObj.message;
          }

          // this.UploadS3method(ResultObj.message, key);
        }
        this.overlay = false;
        // console.log("Result", ResultObj);
      } catch (error) {
        this.overlay = false;
        console.log("Error", error);
      }
    },

    async UploadS3method(UploadURL, key) {
      try {
        let config = {
          method: "get",
          maxBodyLength: Infinity,
          url: UploadURL,
          // headers: {
          //   "Content-Type": file.type,
          // },
          // data: file,
        };
        let result = await axios(config);
        console.log("resultresult", result);
        if (result.status === 200 && result.statusText === "OK") {
          // if (key.includes("LICENSE_BACK") || key.includes("LICENSE_FRONT")) {
          return `data:image/jpeg;base64,${result.data}`;
          // } else {
          //   this.profile_pic_url = `https://makeithomesafe.s3.ap-south-1.amazonaws.com/${key}`;
          //   console.log("check Profile Pic", this.profile_pic_url);
          //   // this.loading = true;
          // }
        }
        console.log("Uploaded result", result);
      } catch (error) {
        console.log("error", error);
      }
    },
    base64ToBlob(base64, mimeType = "image/png") {
      const byteCharacters = atob(base64); // Decode Base64
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      return new Blob(byteArrays, { type: mimeType });
    },
  },
};
